import { render, staticRenderFns } from "./BeauticianOrders.vue?vue&type=template&id=5dc0896d"
import script from "./BeauticianOrders.vue?vue&type=script&lang=js"
export * from "./BeauticianOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports